import React from 'react';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { COMPACT_DATE_TIME_FORMAT } from '../../utils/timeFormatter';

/**
 * Year-less date-time picker whose action bar sets the current moment
 * (MUI's "today" action keeps the time on date-time pickers, relabelled "Now").
 * @param {Object} props
 * @param {string|null} props.value - ISO date-time
 * @param {Function} props.onChange - Called with an ISO string, minutes precision
 */
const CompactDateTimePicker = ({ value, onChange }) => (
  <LocalizationProvider dateAdapter={AdapterDayjs} localeText={{ todayButtonLabel: 'Now' }}>
    <DateTimePicker
      value={value ? dayjs(value) : null}
      onChange={(next) => next?.isValid() && onChange(next.second(0).millisecond(0).format())}
      format={COMPACT_DATE_TIME_FORMAT}
      ampm={false}
      slotProps={{
        textField: { size: 'small', fullWidth: true },
        actionBar: { actions: ['today', 'accept'] },
      }}
    />
  </LocalizationProvider>
);

export default CompactDateTimePicker;
